import React from 'react';
import { Logo } from '../ui/Logo';

export function Footer() {
  return (
    <footer className="bg-green-900 text-white/80 py-10 md:py-14 border-t border-white/10">
      <div className="max-w-shell mx-auto px-4 md:px-6 flex flex-col md:flex-row gap-8 md:items-center md:justify-between">
        <div className="flex flex-col gap-3">
          <Logo variant="on-green" size="md" markSize={28} />
          <p className="font-body text-small text-white/65 max-w-sm">
            Seu álbum, suas trocas, sua galera. Feito por torcedor pra torcedor.
          </p>
        </div>
        <div className="flex flex-col md:items-end gap-2">
          <span className="font-body text-caption text-white/55">
            © 2026 BoraTrocar
          </span>
          <span className="font-body text-caption text-white/45">
            Não somos afiliados à FIFA, Panini ou Coca-Cola.
          </span>
        </div>
      </div>
    </footer>
  );
}
